import React from 'react';

class FileInput extends React.Component {


	// REACT APP CONSTRUCTOR
	// =============================================================================================
	constructor( props ) {

		super( props );

		this.state = {};
	}


	// MAIN RENDER METHOD
	// =============================================================================================
	render() {
		return <div className="btn btn_blue">
			<input type="file" onChange={ this.props.onChange } accept={ this.props.accept } />
			{ this.props.text }
		</div>;
	}
}

export default FileInput;


// WEBPACK FOOTER //
// ./src/scenes/Editor/file-input.js